import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceBase } from '../shared/servicebase';


export interface LogEntry {
  timestamp: string;
  product: string;
  layer: string;
  location: string;
  message: string;
}

export interface LogsResponse {
  usageLogs: LogEntry[];
  errorLogs: LogEntry[];
}

@Injectable({ providedIn: 'root' })
export class AdminService extends ServiceBase{
  private logsUrl = this.apiBaseUrl + 'Logs';
  private filteredlogsUrl = this.apiBaseUrl + 'Logs/filter'

  constructor(private http: HttpClient) {
      super();
  }

  /**
   * Fetch both usage and error logs from the API in a single call.
   */
  getLogs(): Observable<LogsResponse> {
    return this.http.get<LogsResponse>(this.logsUrl);
  }

  /**
   * Fetch logs from the API using filter criteria.
   * @param filter { type: 'usage'|'error', startDate?: string, endDate?: string, message?: string }
   */
  getFilteredLogs(filter: { type: 'usage'|'error', startDate?: string, endDate?: string, message?: string }): Observable<LogsResponse> {
    // Build query params
    const params: any = {};
    if (filter.type) params.type = filter.type;
    if (filter.startDate) params.startDate = filter.startDate;
    if (filter.endDate) params.endDate = filter.endDate;
    if (filter.message) params.message = filter.message;
    return this.http.get<LogsResponse>(this.filteredlogsUrl, { params });
  }  
  
  /**
   * Update the claim number for a given reference number.
   * @param referenceNumber The reference number of the claim to update
   * @param newClaimNumber The new claim number to set
   */
  updateClaim(referenceNumber: string, newClaimNumber: string): Observable<any> {
    const url = this.apiBaseUrl + 'Claim/claimreferencenumber';
    return this.http.put(url, { id: referenceNumber, claimReferenceNumber: newClaimNumber });
  }
}
